import { render, staticRenderFns } from "./GeneralPost.vue?vue&type=template&id=5dce4802&scoped=true&"
import script from "./GeneralPost.vue?vue&type=script&lang=js&"
export * from "./GeneralPost.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPost.vue?vue&type=style&index=0&id=5dce4802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce4802",
  null
  
)

export default component.exports